// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000'
export const MEDIA_URL = import.meta.env.VITE_MEDIA_URL || 'http://localhost:8000'
